import { render, staticRenderFns } from "./ParallelSourceAndTargets.vue?vue&type=template&id=3dac6025&scoped=true"
import script from "./ParallelSourceAndTargets.vue?vue&type=script&lang=ts"
export * from "./ParallelSourceAndTargets.vue?vue&type=script&lang=ts"
import style0 from "./ParallelSourceAndTargets.vue?vue&type=style&index=0&id=3dac6025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac6025",
  null
  
)

export default component.exports